
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import CPDueDiligenceAccountHolderDetails from './CPDueDiligenceAccountHolderDetails.vue';
import { DueDiligenceAccountHolderDetails } from '@/store/dueDiligence/types';
import CPDueDiligencePlannedInvestmentVolume from './CPDueDiligencePlannedInvestmentVolume.vue';
import { JointAccountTypes } from '@/types/jointAccountType';

@Component({
    components: {
        CPDueDiligenceAccountHolderDetails,
        CPDueDiligencePlannedInvestmentVolume
    }
})
export default class CPDueDiligenceGeneralDetails extends Vue {
    public readonly jointAccountTypes = JointAccountTypes;
    
    public get primaryAccountHolder(): DueDiligenceAccountHolderDetails {
        return this.$store.state.dueDiligence.details.GeneralDetails.PrimaryAccountHolder;
    }

    public get secondaryAccountHolder(): DueDiligenceAccountHolderDetails | null {
        return this.$store.state.dueDiligence.details.GeneralDetails.SecondaryAccountHolder;
    }
}
